// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__34SvF","requiredAsterisk":"Info_requiredAsterisk__2KdCs"};